/* eslint-disable react/jsx-props-no-spreading */
import './TextArea.scss';

import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

const TextArea = ({
  className,
  context,
  disabled,
  id,
  name,
  onChange,
  placeholder,
  readOnly,
  required,
  value,
  variant,
}) => {
  const classNames = useMemo(
    () =>
      [
        'textarea',
        disabled || readOnly ? 'textarea--disabled' : null,
        variant ? `textarea--${variant}` : null,
        className,
      ]
        .filter((val) => val)
        .join(' '),
    [className, disabled, readOnly, variant],
  );

  const handleChange = useCallback(
    (e) => {
      onChange(e);
    },
    [onChange],
  );

  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
      ...{
        'data-qa-id': `${context || 'textarea'}-${
          disabled ? 'disabled' : 'active'
        }`,
      },
    }),
    [context, disabled, id],
  );

  return (
    <textarea
      className={classNames}
      disabled={disabled}
      {...conditionalProps}
      name={name || id}
      onChange={handleChange}
      placeholder={placeholder}
      readOnly={readOnly}
      required={required}
      value={value}
    />
  );
};

TextArea.defaultProps = {
  className: '',
  context: null,
  disabled: false,
  id: null,
  name: '',
  onChange: () => {},
  placeholder: '',
  readOnly: false,
  required: false,
  value: '',
  variant: null,
};

TextArea.propTypes = {
  className: PropTypes.string,
  context: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
};

export default TextArea;
